function isInstantlyCallableThunkAction(action) {
    return action.instantlyCallable;
}
/**
 * Makes instantly callable thunk actions dispatchable directly.
 */
export const instantlyCallableThunkActionMiddleware = () => (next) => (action) => next(isInstantlyCallableThunkAction(action) ? action() : action);
